import type { RecommendationTypeName } from '~~/types/localization/localizationHelperTypes';
import type { LastSeenProduct } from '~~/types/product/LastSeenProduct';

export const useRecommendationIntersection = ({
  lastSeenProducts,
  recommendationType,
}: {
  lastSeenProducts?: Ref<LastSeenProduct[]>,
  recommendationType?: RecommendationTypeName
}) => {

  const {
    triggerGtmRecommendationEvent,
  } = useRecommendationEvent({ recommendationType });

  const { onIntersectOnce } = useIntersectionObserverEvent({
    onIntersectCallback: () => {

      if (lastSeenProducts?.value?.length) {

        triggerGtmRecommendationEvent({ lastSeenProducts: lastSeenProducts.value });
      
      }
    
    },
  });

  return {
    onIntersectOnce,
  };

};
